(function () {
  var cameFromCheckout = document.referrer && document.referrer.indexOf('/checkouts/') !== -1;
  if (!cameFromCheckout) return;
  
  if (window.__mbCartItemCount !== 0) return;
  
  var raw = sessionStorage.getItem('campaign_attributes');
  if (!raw) return;
  
  try {
    var campaign = JSON.parse(raw);
    if (campaign.lp_url) {
      window.location.href = campaign.lp_url;
    }
  } catch (e) {
    console.error('campaign_attributes parse failed:', e);
  }
})();
